import { useState } from "react";

import { AddAccountInstructionsSheet } from "features/add-account-instructions";
import { Description } from "pages/ui/page";
import { Panel } from "shared/ui/panel";
import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  instructions?: string;
  onChange: (value: string) => void;
};

export const InstructionsField = (props: Props) => {
  const { className, instructions, onChange } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className={cn("flex flex-col gap-2", className)}>
      <Description>Instructions</Description>

      <p className="text-sm leading-5 tracking-[0.4px] text-white/40">
        Explain how Resonar should use this account — what it is for and when
        to prefer it over your other accounts. Optional.
      </p>

      <Panel
        className={cn("truncate", !instructions && "text-pale-grey")}
        onClick={() => setIsOpen(true)}
      >
        {instructions || "How you want me to use it"}
      </Panel>

      <AddAccountInstructionsSheet
        value={instructions}
        onChange={onChange}
        title={instructions ? "Account Instructions" : "Add Instructions"}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </section>
  );
};
